// src/firebase.js

// Firebase core and services
import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, FacebookAuthProvider, connectAuthEmulator } from 'firebase/auth';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getStorage } from 'firebase/storage'; // ✅ For uploading media
import { getFunctions } from 'firebase/functions';

// Pass 86P — `authDomain` is config-driven so the Google OAuth flow can later present the Voletus hostname
// instead of the legacy Firebase hostname that briefly flashes today. It DEFAULTS to the proven working value, so
// behaviour is unchanged unless `REACT_APP_AUTH_DOMAIN` is set in the production build. DO NOT flip it to
// app.voletus.com until the custom domain actually serves Firebase's reserved auth handler at
// `https://app.voletus.com/__/auth/handler` AND that URI is added to the Google Cloud OAuth client's authorized
// redirect URIs and Firebase Auth authorized domains — otherwise Google sign-in breaks. See docs/NEXT_PASS_HANDOFF.md
// (86P auth-domain) for the exact operator steps; this is a staged cutover, no auth/project migration.
const AUTH_DOMAIN = (typeof process !== 'undefined' && process.env && process.env.REACT_APP_AUTH_DOMAIN)
  || "sports-video-anaylsis.firebaseapp.com";

// ✅ Your Firebase project configuration
const firebaseConfig = {
  apiKey: "AIzaSyBb_HkaD_0VRjXQyAu94rlU5MZA8fKQ3oM",
  authDomain: AUTH_DOMAIN,
  projectId: "sports-video-anaylsis",
  storageBucket: "sports-video-anaylsis.firebasestorage.app",
  messagingSenderId: "718709585690",
  appId: "1:718709585690:web:64daebf5ace2c624c65ea3",
  measurementId: "G-YNMDW1RYVB"
};

// ✅ Initialize Firebase App
const app = initializeApp(firebaseConfig);

// ✅ Initialize services
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
const functions = getFunctions(app);
const googleProvider = new GoogleAuthProvider();
const facebookProvider = new FacebookAuthProvider();

// ── Local Emulator wiring (scheduling pilot demo) ──
// Only connects when REACT_APP_USE_EMULATOR=true (set by `npm run dev:scheduling`).
// A production build without that env var NEVER connects to an emulator, so this
// can never accidentally point real users at local data.
if (process.env.REACT_APP_USE_EMULATOR === 'true' && typeof window !== 'undefined') {
  const host = process.env.REACT_APP_EMULATOR_HOST || '127.0.0.1';
  try {
    connectAuthEmulator(auth, `http://${host}:9099`, { disableWarnings: true });
    connectFirestoreEmulator(db, host, 8080);
    // eslint-disable-next-line no-console
    console.info('%c[firebase] Connected to LOCAL EMULATORS — no production data is used.', 'color:#16A34A;font-weight:bold');
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('[firebase] Failed to connect to emulators:', err);
  }
}

// ✅ Export for use throughout the app
export { auth, db, storage, functions, googleProvider, facebookProvider };
